// Website-published project snapshot. Source: https://www.oceansideliving.com.au/projects
// Recheck every status before launch. These are projects, not available sales inventory.

export type ProjectStatus = "Completed" | "In progress" | "Underway" | "Upcoming";

export type Project = {
  slug: string;
  suburb: string;
  status: ProjectStatus;
  buildType: string;
  description: string;
  finishes?: string[];
  image?: string;
  serviceLink?: { label: string; to: string };
};

export const projects: Project[] = [
  {
    slug: "mindarie",
    suburb: "Mindarie",
    status: "Completed",
    buildType: "Double-storey home",
    description: "A double-storey home completed in Mindarie, designed with quality and attention to detail in mind.",
    finishes: ["Full-height tiling to wet areas", "Stone benchtops", "Custom cabinetry", "Glass balustrading", "Feature lighting"],
    image: "https://cdn.magicpatterns.com/uploads/us3G3sE5heZnF96y2kA1ML/Mindarie_Frontage_-_Completed.avif",
    serviceLink: { label: "Discuss a custom home", to: "/contact?project=custom" },
  },
  {
    slug: "eglinton",
    suburb: "Eglinton",
    status: "Completed",
    buildType: "Single-storey home",
    description: "A single-storey home in Eglinton, designed with comfort, quality and contemporary living in mind.",
    finishes: ["Full-height tiling to bathrooms", "Stone benchtops", "Premium finishes throughout"],
    image: "https://cdn.magicpatterns.com/uploads/8gpwxwDPygyEEbAbT1wLwQ/Newton_St_Frontage_-_complete.avif",
    serviceLink: { label: "Explore single-storey designs", to: "/home-designs" },
  },
  {
    slug: "padbury",
    suburb: "Padbury",
    status: "In progress",
    buildType: "Double-storey corner-block home",
    description: "A double-storey residence taking shape on a corner block, with a design that responds to the opportunities of the site and delivers strong street appeal.",
  },
  {
    slug: "dianella",
    suburb: "Dianella",
    status: "Underway",
    buildType: "Knock-down/rebuild duplex",
    description: "A knock-down and rebuild duplex development, underway following demolition of the original dwelling. Designed to optimise land use and functionality.",
    serviceLink: { label: "About investments and developments", to: "/#developments" },
  },
  {
    slug: "karrinyup",
    suburb: "Karrinyup",
    status: "Upcoming",
    buildType: "Double-storey home on a 10m-wide block",
    description: "An upcoming double-storey home on a premium 10-metre-wide block, designed to make the most of the site's potential.",
    serviceLink: { label: "Talk about a narrow block", to: "/contact?project=custom" },
  },
];
